import { makeStyles } from '@material-ui/styles'
import React from 'react'
import ReactDOM from 'react-dom'
import { BannerContext } from 'core/providers/BannerProvider'
import Theme from 'core/themes/model'

const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    // Intercom uses a ridiculously high zIndex so we have to be even more ridiculous
    zIndex: 9999999998,
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
    top: 55,
    left: 0,
    right: 0,
    minHeight: 45,
    color: theme.palette.red[500],
    backgroundColor: theme.palette.red[100],
    borderBottom: `2px solid ${theme.palette.red[500]}`,
  },
}))

const BannerContent = ({ children }: { children: React.ReactNode | JSX.Element }) => {
  const classes = useStyles()
  const { bannerContainer } = React.useContext(BannerContext)
  if (!bannerContainer) {
    return null
  }

  return ReactDOM.createPortal(<div className={classes.root}>{children}</div>, bannerContainer)
}

export default BannerContent
